












































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IPeriod } from "@/store/modules/section/types";
import { IUSection } from "@/store/types";
import { Getter } from "vuex-class";

const namespace = "authModule";

@Component({
  name: "sections",
})
export default class Sections extends Vue {
  @Prop({ default: "" })
  public period!: IPeriod;

  @Prop({ default: "" })
  public season!: string;

  private reviewUrl(section: IUSection): string {
    return `/assessment/review/${section.subject}/${section.test_num}`;
  }

  get sections() {
    const period = this.period;
    return period.sections;
  }

  public takeSectionLabel(section: IUSection) {
    let label = "Start Section";

    if (section.is_started && !section.is_completed) {
      label = "Continue Section";
    } else if (section.is_completed) {
      label = "Review Section";
    }
    return label;
  }
}
